/** Info detallada por lugar — consejos para primera vez en Tokio */

export const LUGARES_INFO = {
	yoyogi: {
		title: "Yoyogi",
		tagline: "Naturaleza en el corazón de la ciudad",
		description:
			"Yoyogi es el pulmón verde de esta zona de Tokio. Dentro del parque se encuentra el Santuario Meiji, dedicado al emperador Meiji y su esposa. Está rodeado por un bosque con más de 100.000 árboles donados desde todo Japón, creando un ambiente súper tranquilo en pleno centro de la ciudad. Es uno de los santuarios más visitados del país y el lugar perfecto para empezar el día con calma.",
		highlights: [
			"Santuario Meiji",
			"Yoyogi Park",
			"Puerta torii principal",
			"Barriles de sake decorativos",
		],
		firstVisit:
			"Entra por la puerta torii principal y sigue el sendero hasta el santuario. Antes de entrar, puedes hacer el ritual tradicional de purificación en el temizuya, lavándote las manos y la boca. Si tienes suerte, quizá coincidas con una boda japonesa tradicional.",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Estación Harajuku (JR Yamanote) o Meiji-Jingumae (metro Chiyoda/Fukutoshin). El santuario está a 5 min a pie.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "Temprano (8:00–10:00) entre semana, o domingo por la tarde si quieres ver bodas tradicionales shinto.",
			},
			{
				icon: "budget",
				title: "Presupuesto",
				text: "Entrada gratuita al santuario y al parque.",
			},
		],
	},
	harajuku: {
		title: "Harajuku",
		tagline: "Moda kawaii, tiendas curiosas y cultura juvenil",
		description:
			"Harajuku es uno de los barrios más famosos de Tokio por su cultura kawaii y su moda callejera. Takeshita Street está llena de tiendas originales, accesorios curiosos, cafeterías temáticas y puestos de crepes gigantes. A pocos minutos está Omotesando, una gran avenida con tiendas de lujo y edificios de diseño.",
		highlights: [
			"Takeshita Street",
			"Crepes Marion",
			"Omotesando",
			"Tiendas vintage",
			"Kiddy Land en Omotesando",
			"Cat Street",
		],
		firstVisit:
			"Empieza por Takeshita (entrada junto a Harajuku Station) y baja hasta el final. Luego cruza a Omotesando.",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Estación Harajuku (salida Takeshita-guchi). Desde Yoyogi son 10 min caminando.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "11:00–16:00 para ambiente animado. Evita domingo tarde si no te gustan las multitudes.",
			},
		],
		food: {
			icon: "crepe",
			text: "Crepes en Takeshita, poke bowls en Harajuku, o un café en Omotesando (Blue Bottle, % Arabica).",
		},
	},
	shibuya: {
		title: "Shibuya",
		tagline: "El cruce más famoso del planeta",
		description:
			"Shibuya representa el Tokio más moderno: neones, pantallas gigantes, moda y miles de personas cruzando las calles a todas horas. El famoso cruce de Shibuya es el más transitado del mundo y cuando los semáforos se ponen en verde, cientos de personas cruzan a la vez desde todas direcciones. Muy cerca está la estatua de Hachiko, el perro más famoso de Japón.",
		highlights: [
			"Shibuya Crossing",
			"Estatua de Hachiko",
			"Shibuya Sky",
			"Shibuya 109",
			"Nonbei Yokocho",
			"Center-gai",
		],
		firstVisit:
			"Cruza el paso de peatones desde distintos puntos y disfruta de las vistas desde el Starbucks Tsutaya (2ª planta). Si puedes, sube a Shibuya Sky al atardecer (mejor reservar online).",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Shibuya Station (JR, metro Ginza/Hanzomon/Fukutoshin). Desde Harajuku: 1 parada Yamanote o 15 min a pie.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "Tarde-noche (17:00–22:00) para el cruce con luces. Shibuya Sky: reserva hora del atardecer.",
			},
			{
				icon: "budget",
				title: "Presupuesto",
				text: "Shibuya Sky cuesta alrededor de 2.700–3.000¥ (mejor reservar online)",
			},
			{
				icon: "photo",
				title: "Primera vez",
				text: "No te quedes solo en el cruce: conoce Center-gai (calles con tiendas) y Nonbei Yokocho (bares).",
			},
		],
	},
	ueno: {
		title: "Ueno",
		tagline: "Parque, mercados y ambiente local",
		description:
			"Aquí encontrarás algunos de los museos más importantes de Tokio, el zoo más antiguo de Japón y uno de los parques más populares para ver los cerezos en flor durante la primavera. Muy cerca está Ameya-Yokocho (Ameyoko), un animado mercado callejero bajo las vías del tren perfecto para probar comida japonesa barata y comprar snacks.",
		highlights: ["Ueno Park", "Ameyoko market", "National Museum", "Ueno Zoo"],
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Ueno Station (JR Yamanote, metro Ginza/Hibiya). Muy bien conectado desde cualquier punto.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "Mañana (9:00–12:00) para zoo y museos. Ameyoko animado al mediodía y tarde.",
			},
			{
				icon: "budget",
				title: "Presupuesto",
				text: "Parque gratis. Zoo ~600¥. Museos 500–1.000¥. Ameyoko muy económico.",
			},
		],
		food: {
			icon: "seafood",
			text: "Ameyoko es perfecto para probar street food japonés barato: brochetas, takoyaki, marisco, snacks y pequeños puestos locales.",
		},
	},
	asakusa: {
		title: "Asakusa",
		tagline: "El Tokio antiguo que no puedes perderte",
		description:
			"Asakusa es el barrio más tradicional e histórico de Tokio. Aquí se encuentra el templo Senso-ji, fundado en el año 645 y considerado el templo más antiguo de la ciudad. La calle Nakamise conecta la famosa puerta Kaminarimon (con su enorme linterna roja) con el templo y está llena de tiendas de souvenirs, dulces tradicionales y artesanía japonesa.",
		highlights: ["Senso-ji", "Kaminarimon", "Nakamise-dori", "Rio Sumida"],
		firstVisit:
			"Hazte la foto típica en Kaminarimon, recorre la calle Nakamise entre tiendas tradicionales y visita el templo Senso-ji. Si te apetece, también puedes terminar la visita con un paseo en barco por el río Sumida",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Asakusa Station (metro Ginza/Asakusa). Desde Ueno: 2 paradas o 20 min a pie.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "Muy temprano (7:00–9:00) para fotos sin gente o al atardecer para ver las luces del templo.",
			},
			{
				icon: "budget",
				title: "Presupuesto",
				text: "Templo gratuito.",
			},
			{
				icon: "temple",
				title: "Primera vez",
				text: "Prueba ningyo-yaki (dulce relleno) y senbei (galletas de arroz). ",
			},
		],
		food: {
			icon: "street",
			text: "En Nakamise encontrarás dulces tradicionales y snacks japoneses. Cerca del templo, Daikokuya es famoso por su tempura y también hay restaurantes especializados en unagi (anguila).",
		},
	},
	akihabara: {
		title: "Akihabara",
		tagline: "Paraíso del anime, manga y electrónica",
		description:
			"Akihabara (Akiba) es el paraíso de la cultura otaku. Anime, manga, figuritas, gachapon, recreativos y tiendas de electrónica llenan sus calles. A lo largo de Chuo-dori encontrarás edificios repletos de tiendas y arcades gigantes con muchísimo ambiente.",
		highlights: [
			"Electric Town",
			"Mandarake",
			"Arcades (GiGO)",
			"Gachapon",
			"Super Potato",
			"Chuo-dori",
		],
		firstVisit:
			"Empieza por la estación y sube Chuo-dori. Entra en Mandarake (varios pisos de coleccionables) aunque no compres, es una experiencia. Prueba un gachapon antes de irte.",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Akihabara Station (JR Yamanote, metro Hibiya). Desde Asakusa: 1 parada Tsukuba Express o metro.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "Tarde (14:00–20:00). Domingo si quieres calle peatonal. Muchas tiendas abren a las 10:00.",
			},
			{
				icon: "game",
				title: "Primera vez",
				text: "Tax Free en muchas tiendas (lleva pasaporte). Cuidado con los maid cafés muy caros para turistas",
			},
		],
		food: {
			icon: "food",
			text: "Muchos restaurantes temáticos y ramen barato. La zona no es famosa por gourmet, pero sí por experiencias curiosas.",
		},
	},
	tokyoStation: {
		title: "Tokyo Station",
		tagline: "Historia, compras y mirador gratuito",
		description:
			"Tokyo Station combina historia y compras. Su famosa fachada de ladrillo rojo, inaugurada en 1914, es uno de los edificios más icónicos de la ciudad. Por dentro, la estación parece una pequeña ciudad subterránea: en zonas como GranSta y Character Street encontrarás tiendas temáticas y dulces japoneses. Muy cerca se encuentran los jardines y alrededores del Palacio Imperial, perfectos para pasear. Además, el edificio KITTE tiene un mirador gratuito con buenas vistas de la estación.",
		highlights: [
			"Fachada Marunouchi",
			"GranSta / Character Street",
			"Kitte rooftop",
			"Ekiben",
		],
		firstVisit:
			"Hazte la foto en la fachada de Marunouchi, baja a GranSta para comprar un ekiben típico japonés, pasea por las tiendas de Character Street y termina en el mirador gratuito de KITTE con vistas a Tokyo Station.",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Tokyo Station (JR, metro Marunouchi). Hub central: casi cualquier línea pasa por aquí.",
			},
			{
				icon: "budget",
				title: "Presupuesto",
				text: "Ver la estación gratis. Kitte rooftop gratis.",
			},
			{
				icon: "bento",
				title: "Primera vez",
				text: "Comprar un ekiben y comerlo en un tren Shinkansen es típico japonés.",
			},
		],
		food: {
			icon: "bento",
			text: "Ekiben en GranSta (Daimaru Bento, Kiyoken). Ramen Street en la estación.",
		},
	},
	ginza: {
		title: "Ginza",
		tagline: "El barrio más elegante de Tokio",
		description:
			"Ginza es el barrio más elegante y exclusivo de Tokio. Aquí encontrarás tiendas de lujo, grandes almacenes históricos como Wako o Mitsukoshi, galerías de arte y algunos de los restaurantes más famosos de la ciudad. Los fines de semana, parte de Chuo-dori se cierra al tráfico y se convierte en una gran avenida peatonal. Muy cerca también se encuentra Tsukiji Outer Market, perfecto para probar sushi, marisco y comida callejera japonesa.",
		highlights: [
			"Chuo-dori",
			"Ginza Six",
			"Kabukiza Theatre",
			"Itoya (papelería)",
		],
		firstVisit:
			"Pasea Chuo-dori de arriba a abajo. Entra en Ginza Six (terraza gratis en la azotea). Si es fin de semana, disfruta la calle sin coches.",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Ginza Station (metro Ginza/Marunouchi/Hibiya). Desde Tokyo Station: 10 min a pie por Marunouchi.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "Tarde para compras. Sábado-domingo tarde para Hokoten (calle peatonal). Noche para luces.",
			},
			{
				icon: "cafe",
				title: "Primera vez",
				text: "No hace falta comprar en las tiendas de lujo: la gracia de Ginza es pasear y disfrutar del ambiente. No te pierdas Itoya, una papelería gigante de 12 plantas, ni Hakuhinkan Toy Park, una de las jugueterías más famosas de Tokio.",
			},
		],
	},
	odaiba: {
		title: "Odaiba",
		tagline: "Bahía y vistas de Rainbow Bridge",
		description:
			"Odaiba es una isla artificial en la bahía de Tokio llena de arquitectura futurista, centros comerciales y vistas. Aquí encontrarás el Rainbow Bridge, una pequeña Estatua de la Libertad, playas urbanas y lugares como DiverCity con su famoso Gundam gigante. Es una zona perfecta para pasar la tarde y ver el atardecer sobre la bahía de Tokio.",
		highlights: [
			"Rainbow Bridge",
			"DiverCity Gundam",
			"Liberty Statue",
			"Odaiba Marine Park",
		],
		firstVisit:
			"Llega en la línea Yurikamome, el tren automático con vistas a la bahía de TokiO. Hazte la foto con el Gundam gigante de DiverCity, pasea junto al agua al atardecer y termina el día cenando en Aqua City o Decks.",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Yurikamome desde Shimbashi (vistas increíbles) o Rinkai Line. Más espectacular que el metro.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "Tarde hasta noche (16:00–21:00). Rainbow Bridge se ilumina al anochecer.",
			},
			{
				icon: "bridge",
				title: "Primera vez",
				text: "El Yurikamome no esta incluido en el JR Pass, necesitas tarjeta Suica/Pasmo. Sube delante del tren para mejores vistas.",
			},
		],
	},
	torreTokio: {
		title: "Torre de Tokio",
		tagline: "El skyline clásico de Tokio",
		description:
			"Inspirada en la Torre Eiffel, la Torre de Tokio se ha convertido en uno de los símbolos más famosos de la ciudad desde 1958. Con sus 333 metros de altura y su característico color naranja y blanco, ofrece vistas panorámicas desde sus dos miradores. A sus pies se encuentra el templo Zojo-ji, creando uno de los contrastes más bonitos entre tradición y modernidad en Tokio.",
		highlights: ["Mirador principal", "Mirador top deck", "Templo Zojo-ji"],
		firstVisit:
			"Compra entrada online (más barata). Sube de día y quédate hasta que encienden las luces.",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: "Akabanebashi (metro Oedo) u Onarimon (metro Mita). Desde ambas estaciones son unos 5–10 min caminando.",
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "1 h antes del atardecer para ver día + noche. Viernes-sábado hay iluminación especial a veces.",
			},
			{
				icon: "budget",
				title: "Presupuesto",
				text: "Mirador principal desde ~1.500¥. El Top Deck cuesta extra. Reservando online suele haber descuento.",
			},
			{
				icon: "tower",
				title: "Primera vez",
				text: "Si eliges una torre: Tokyo Tower = clásica naranja, Tokyo Skytree = más alta y moderna.",
			},
		],
	},
	shinjuku: {
		title: "Shinjuku",
		tagline: "Rascacielos, izakayas y ambiente nocturno",
		description:
			"Shinjuku representa el Tokio más animado. Cada día pasan millones de personas por su estación, la más transitada del mundo. Aquí encontrarás los neones y pantallas gigantes de Kabukicho, los pequeños bares de Golden Gai y los callejones llenos de yakitori de Omoide Yokocho bajo las vías del tren. Además, el observatorio gratuito del Tokyo Metropolitan Government Building ofrece unas vistas espectaculares de la ciudad.",
		highlights: [
			"Golden Gai",
			"Omoide Yokocho",
			"Kabukicho",
			"Vista gratis TMG Building",
		],
		firstVisit:
			"Empieza con las vistas gratuitas desde el mirador del Tokyo Metropolitan Government Building al atardecer. Después, prueba unos yakitori en Omoide Yokocho, entra a alguno de los diminutos bares de Golden Gai y termina paseando entre los neones de Kabukicho por la noche",
		tips: [
			{
				icon: "train",
				title: "Cómo llegar",
				text: 'Shinjuku Station. Sigue señales "East Exit" para Kabukicho, "West" para la zona de rascacielos.',
			},
			{
				icon: "time",
				title: "Mejor momento",
				text: "La mejor hora es al atardecer y por la noche. Golden Gai suele tener más ambiente a partir de las 20:00.",
			},
		],
		food: {
			icon: "night",
			text: "Omoide Yokocho y Memory Lane son perfectos para probar yakitori y cerveza entre pequeños bares tradicionales. Si quieres cambiar totalmente de ambiente, Shin-Okubo está lleno de restaurantes coreanos y street food.",
		},
	},
};
